import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import CustomerSettingSidebar from '../layouts/CustomerSettingSidebar'
// import Select from "react-select";

import FeatherIcon from 'feather-icons-react';
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
// import { useFormik } from "formik";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const CustomerProfileSettings = () => {
  let { id } = localStorage.getItem('auth_id');

  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  
  const formik = useFormik({
    initialValues: {
      id: value.id,
      profile_image: value.profile_image,
      user_type: value.user_type,
      user_first_name: value.user_first_name,
      user_last_name: value.user_last_name,
      user_function: value.user_function,
      user_email: value.user_email
    },
    enableReinitialize: true,
    // validationSchema: EditUserSchema,
    onSubmit: (values, actions) => {
      axios
        .post("/customerportal/user/update", values, {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          actions.setSubmitting(false);

          if (response.data.code === 200) {
            toast.success(response.data.message);
            
            let profile_image = response.data.data.user.profile_image;
            let auth_fname = response.data.data.user.user_first_name;
            let auth_lname = response.data.data.user.user_last_name;
            localStorage.setItem("fname", auth_fname);
              localStorage.setItem("lname", auth_lname);
              localStorage.setItem("profile_image", profile_image);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/customerportal/update-profile"; 
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        }).catch((error) => {
          console.log(error);
          actions.setSubmitting(false);
        });
    },
  });

  var auth_profile_image = '';
  useEffect(() => {
    axios
      .get(`/customerportal/user/edit/${localStorage.getItem('auth_id')}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          //toast.error(response.data.data.user);
          var user_data = response.data.data.user;

          setValue(user_data);

          AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
          AWS.config.update({
          accessKeyId: AWS_ACCESS_KEY_ID,
          secretAccessKey: AWS_SECRET_ACCESS_KEY,
          region: AWS_DEFAULT_REGION,
          signatureVersion: 'v4',
          });
          const s3 = new AWS.S3();
          var params = {Bucket: AWS_BUCKET, Key: user_data.profile_image};
          auth_profile_image = s3.getSignedUrl('getObject', params);
          user_data.profile_image = auth_profile_image;
          setValue(user_data);

        }
      })
      .catch((error) => {
        console.log(error);
      });

  
  }, [id]);

  const customHandleInput = (event) => {
    const Input_name = event.name;
    delete backendErrors[Input_name];
  };
console.log(auth_profile_image);
  const toggleMobileMenu = () => {
    setMenu(!menu)
  }
  console.log(value);
  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? 'slide-nav': ''}`}> 
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar /> 	<ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-6">
                <h3 className="page-title">Update Profile</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"> <Link to="/customerportal/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Update Profile</li>
                </ul>
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-xl-2 col-md-3">
              <CustomerSettingSidebar />
            </div>
            
            <div className="col-xl-10 col-md-9">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">User Information</h5>
                </div>
                <div className="card-body">
                   <FormikProvider value={formik}>
                   <form action="#" onSubmit={formik.handleSubmit}>
                   <div className="row"> <div className="col-lg-10">
                      <div className="text-center py-5">
                        <label
                          className="avatar avatar-xxl profile-cover-avatar"
                          htmlFor="avatar_upload"
                        >
                          <img  className="avatar-img"  src={  formik.values.profile_image } alt="Profile Image" />
                          <input
                            type="file"
                            id="avatar_upload"
                            onChange={(event) => {
                              const file = event.target.files[0];
                              const reader = new FileReader();

                              reader.onloadend = () => {
                                formik.handleChange({
                                  target: {
                                    name: "profile_image",
                                    value: reader.result,
                                  },
                                });
                              };

                              if (file) {
                                reader.readAsDataURL(file);
                              }
                            }}
                          />
                          <span className="avatar-edit">
                            <FeatherIcon
                              icon="edit-2"
                              className="avatar-uploader-icon shadow-soft"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="user_first_name"
                            value={formik.values.user_first_name}
                            className="form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_first_name && (
                              <span className="form-error mt-1">
                                {backendErrors.user_first_name}
                              </span>
                            )}
                          </small>
                        </div>
                       
                        
                      </div>
                     
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Last Name</label>
                          <input
                            type="text"
                            value={formik.values.user_last_name}
                            name="user_last_name"
                            className="form-input form-control"
                             onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }} 
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_last_name && (
                              <span className="form-error mt-1">
                                {backendErrors.user_last_name}
                              </span>
                            )}
                          </small>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                      <div className="form-group">
                          <label>Email</label>
                          <input
                            type="text"
                            value={formik.values.user_email}
                            name="user_email"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                          
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_email && (
                              <span className="form-error mt-1">
                                {backendErrors.user_email}
                              </span>
                            )}
                          </small>
                        </div>
                      
                      </div>
                      <div className="col-md-12">
                      <div className="form-group">
                          <label>Function</label>
                          <input
                            type="text"
                            value={formik.values.user_function}
                            name="user_function"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_function && (
                              <span className="form-error mt-1">
                                {backendErrors.user_function}
                              </span>
                            )}
                          </small>
                        </div>
                      
                      </div>
                    </div>
                    <small>
                      
                      {backendErrors.status && (
                        <span className="form-error mt-1">
                          {backendErrors.status}
                        </span>
                      )}
                    </small>
                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={formik.isSubmitting}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                   </FormikProvider>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>		
  );
}

export default CustomerProfileSettings;